export const DOCUMENT_BLOCK_TYPES = {
  TITLE: "title",
  DATE: "date",
  PARAGRAPH: "paragraph",
  SPACER: "spacer",
  ROW: "row",
  SIGNATURE_TWO_COLUMNS: "signature_two_columns",
};

export const DOCUMENT_ALIGN = {
  LEFT: "left",
  CENTER: "center",
  RIGHT: "right",
  JUSTIFY: "justify",
};